import { render, staticRenderFns } from "./AdminHandlingFees.vue?vue&type=template&id=4df6ceb3&scoped=true&"
import script from "./AdminHandlingFees.vue?vue&type=script&lang=js&"
export * from "./AdminHandlingFees.vue?vue&type=script&lang=js&"
import style0 from "./AdminHandlingFees.vue?vue&type=style&index=0&id=4df6ceb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df6ceb3",
  null
  
)

export default component.exports